import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-animated-scrollcard-type2',
  templateUrl: './animated-scrollcard-type2.component.html',
  styleUrls: ['./animated-scrollcard-type2.component.scss']
})
export class AnimatedScrollcardType2Component {

    @Input() data: any;
    @Input() item: any;
    @Input() images: any;


    loaderHeight: number = 0;
    totalItems: number = 0;
    viewedItems: number = 0;
    public serverPath1 = environment.commonImageApi + '/home/';
    
  
   
  }
    

